import { authorize, postRequest } from 'utils/http';
import { AWS_API_URL } from 'global/environment';

export async function addRSSFeedAPI(url) {
  const backendUrl = `${AWS_API_URL}/rss-feeds`;
  return postRequest(backendUrl, { url }, await authorize());
}
